import type {Type} from '@Components/button';
import styles from './actionable-popup.module.scss';

export enum ActionablePopupPosition {
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
}

export enum ActionablePopupCloseButtonPosition {
  TOP_RIGHT_ABOVE_DIALOG = 'top-right-above-dialog',
  TOP_RIGHT = 'top-right',
  NO_BUTTON = 'no-button',
}


export interface ActionablePopupButton {
  text: string;
  onClick: () => void;
  type?: Type;
}

export interface ActionablePopupImage {
  url: string;
  altText: string;
}

export interface ActionablePopupProps {
  body?: string;
  image?: ActionablePopupImage;
  ctaButton: ActionablePopupButton;
  closeButtonPosition?: ActionablePopupCloseButtonPosition;
  onClose: () => void;
  autoDismissAfterMs?: number;
  position?: ActionablePopupPosition;
}

/**
 * How long the exit animation runs before the popup is torn down. Must match the CSS transition
 * duration on the wrapper in actionable-popup.module.scss.
 */
export const EXIT_ANIMATION_DURATION_MS = 300;

export const CLOSE_ICON = 'icon-close';

export const POSITION_CLASS: Record<ActionablePopupPosition, string> = {
  [ActionablePopupPosition.BOTTOM_RIGHT]: styles.bottomRight,
  [ActionablePopupPosition.BOTTOM_LEFT]: styles.bottomLeft,
  [ActionablePopupPosition.TOP_RIGHT]: styles.topRight,
  [ActionablePopupPosition.TOP_LEFT]: styles.topLeft,
};
